import type { SidePanel } from '../types';

export const InvestmentSummaryPanel: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./InvestmentSummaryPanel.vue')),
};
